<template>
<span class="font-D-container font-Cost1">
   
</span>
</template>

<script>

export default {
  name: "BaseMethodCardPricing"
}

</script>

<style scoped>

</style>